import React from 'react';

const ListBlock = ({ block }) => {
  if (!block.items || block.items.length === 0) return null;

  const ListTag = block.listType === 'ordered' ? 'ol' : 'ul';
  
  const isHorizontal = block.layout === 'horizontal' || block.columns;
  const columns = block.columns || 3;
  
  const listClasses = block.listType === 'ordered' 
    ? 'list-decimal list-inside space-y-2 mb-4' 
    : 'list-disc list-inside space-y-2 mb-4';
  
  const getGridColumnsClass = (cols) => {
    const colMap = {
      1: 'grid-cols-1',
      2: 'grid-cols-2',
      3: 'grid-cols-3',
      4: 'grid-cols-4',
      5: 'grid-cols-5',
      6: 'grid-cols-6'
    };
    return colMap[cols] || 'grid-cols-3';
  };
  
  const containerClasses = isHorizontal 
    ? `grid ${getGridColumnsClass(columns)} gap-8 mb-4` 
    : '';

  const renderItem = (item, index) => {
    let formattedText = item.text || '';
    
    if (item.formatting && item.formatting.bold) {
      if (Array.isArray(item.formatting.bold)) {
        if (item.formatting.bold.length > 0 && typeof item.formatting.bold[0] === 'number') {
          const [start, end] = item.formatting.bold;
          const before = formattedText.substring(0, start);
          const boldText = formattedText.substring(start, end);
          const after = formattedText.substring(end);
          formattedText = `${before}<strong>${boldText}</strong>${after}`;
        } else if (item.formatting.bold.length > 0 && typeof item.formatting.bold[0] === 'object') {
          item.formatting.bold.forEach(({ start, end }) => {
            const before = formattedText.substring(0, start);
            const boldText = formattedText.substring(start, end);
            const after = formattedText.substring(end);
            formattedText = `${before}<strong>${boldText}</strong>${after}`;
          });
        } else if (item.formatting.bold.length > 0 && typeof item.formatting.bold[0] === 'string') {
          const sortedWords = [...item.formatting.bold].sort((a, b) => b.length - a.length);
          sortedWords.forEach(word => {
           
            const escapedWord = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            
            const isAlphanumeric = /^[a-zA-Z0-9]+$/.test(word);
           
            const regex = isAlphanumeric 
              ? new RegExp(`\\b(${escapedWord})\\b`, 'g')
              : new RegExp(`(${escapedWord})`, 'g');
            formattedText = formattedText.replace(regex, `<strong>$1</strong>`);
          });
        }
      }
    }

    return (
      <li key={index} className="text-gray-700">
        <span dangerouslySetInnerHTML={{ __html: formattedText }} />
        {item.nestedItems && item.nestedItems.length > 0 && (
          <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
            {item.nestedItems.map((nestedItem, nestedIndex) => (
              <li key={nestedIndex} className="text-gray-600 text-sm">
                {nestedItem.text}
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  };

  if (isHorizontal) {
    const itemsPerColumn = Math.ceil(block.items.length / columns);
    const columnsData = [];
    for (let i = 0; i < columns; i++) {
      columnsData.push(block.items.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn));
    }
    
    return (
      <div className={containerClasses}>
        {columnsData.map((columnItems, colIndex) => (
          <ListTag key={colIndex} className={listClasses}>
            {columnItems.map((item, index) => renderItem(item, colIndex * itemsPerColumn + index))}
          </ListTag>
        ))}
      </div>
    );
  }
  
  return (
    <ListTag className={listClasses}>
      {block.items.map((item, index) => renderItem(item, index))}
    </ListTag>
  );
};

export default ListBlock;

